import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";
import top from "@/pages/global/components/top-bar/top-bar.vue";

import FeedPortlet from "./../components/feed-portlet/feed-portlet.vue";
import { mapState } from "vuex";

export default {
    beforeMount () {
        //if(!this.$store.feed.state.feedLoaded) {
        //this.$store.dispatch('feed/resetFeedState');
        this.$store.dispatch('feed/fetchUserFeed', {
            'userId': this.currentUser.uid,
            'shouldReset': false,
            'isInLoadMoreContext': false,
        })
    },
    components: {
        FeedPortlet,
        navigation,
        bottom,
        top
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            currentUser: state => state.currentUser,
        }),
        ...mapState('feed', {
            FEED_LIMIT: state => state.FEED_LIMIT,
            feedLoaded: state => state.feedLoaded,
            feedPortlets: state => state.feedPortlets,
            feedPortletsCount: state => state.feedPortletsCount,
            feedAlreadyShawnNoMorePopup: state => state.feedAlreadyShawnNoMorePopup,
        }),
    },
    methods: {
        fetchMoreFeed() {
            this.$store.dispatch('feed/fetchMoreFeed');
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/feed/master/feed.js